import { SendBulkSmsComponent } from '../../../../../../campaigns/src/lib/components/send-bulk-sms/send-bulk-sms.component';
import { SendBulkEmailComponent } from '../../../../../../campaigns/src/lib/components/send-bulk-email/send-bulk-email.component';
import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import {
  CampaignSource,
  EmailSendType,
  SMSSendType,
  TableAction,
  TaskCreateType,
  WhatsAppSendType,
} from '@fitness-force/enum';
import {
  ReportDataForCampaign,
  ReportTableColumnData,
} from '@fitness-force/models';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { CreateOpportunityComponent } from '@fitness-force/crm';
import { TaskCreateComponent } from '../../task/task-create/task-create.component';
import { BehaviorSubject } from 'rxjs';
import { SendWhatsappComponent } from 'libs/campaigns/src/lib/components/send-whatsapp/send-whatsapp.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'table-action-buttons',
  templateUrl: './table-action-buttons.component.html',
  styleUrls: ['./table-action-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    RippleModule,
    CreateOpportunityComponent,
    TaskCreateComponent,
    SendBulkEmailComponent,
    SendBulkSmsComponent,
    SendWhatsappComponent,
    TaskCreateComponent,
    TranslateModule
  ]
})
export class TableActionButtonsComponent implements OnInit {
  @Input('columnData') columnData = new BehaviorSubject<any>([] as []);
  @Input('reportKey') reportKey: any;
  @Input('actionButtons') actionButtons: any;
  @Input('tenantId') tenantId: number = 0;
  @Input('clientIds') clientIds = new BehaviorSubject<number[]>([]);
  @Input('totalRecords') totalRecords = new BehaviorSubject<number>(0);
  @Input('selectedAllData') selectedAllData = new BehaviorSubject<boolean>(false);
  @Input('ReportDataForCampaign') ReportDataForCampaign = new BehaviorSubject<ReportDataForCampaign>({} as ReportDataForCampaign);

  showCreateOpportunityPopup: boolean = false;
  showTaskCreate: boolean = false;
  showBulkEmailPopup: boolean = false;
  showBulkSmsPopup: boolean = false;
  showBulkWhatsAppPopup: boolean = false;
  actionList: any = [];
  EmailSendType: EmailSendType = EmailSendType.Bulk;
  SMSSendType: SMSSendType = SMSSendType.Bulk;
  WhatsAppSendType: WhatsAppSendType = WhatsAppSendType.Bulk;
  TaskCreateType: TaskCreateType = TaskCreateType.Bulk;
  campaignSource: CampaignSource;

  constructor() {}

  ngOnInit(): void {
    this.actionList = ReportTableColumnData.find(
      (c) => c.report_key == this.reportKey
    )!.actions;
  }

  ShowEvent(action: any) {
    switch (action.actionType) {
      case TableAction.Opportunity:
        this.showCreateOpportunityPopup = true;
        break;
      case TableAction.Task:
        {
          this.showTaskCreate = true;
          if (this.selectedAllData.value)
            this.campaignSource = CampaignSource.Report;
          else this.campaignSource = CampaignSource.Clients;
        }
        break;
      case TableAction.SendEmail:
        {
          this.showBulkEmailPopup = true;
          if (this.selectedAllData.value)
            this.campaignSource = CampaignSource.Report;
          else this.campaignSource = CampaignSource.Clients;
        }
        break;
      case TableAction.SendSms:
        {
          this.showBulkSmsPopup = true;
          if (this.selectedAllData.value)
            this.campaignSource = CampaignSource.Report;
          else this.campaignSource = CampaignSource.Clients;
        }
        break;
      case TableAction.SendWhatsApp:
        {
          this.showBulkWhatsAppPopup = true;
          if (this.selectedAllData.value)
            this.campaignSource = CampaignSource.Report;
          else this.campaignSource = CampaignSource.Clients;
        }
        break;
    }
  }

  hideOpportunity(e: any) {
    this.showCreateOpportunityPopup = false;
  }

  HideTaskCreate(e: any) {
    this.showTaskCreate = false;
  }

  HideSendEmail(e: any) {
    this.showBulkEmailPopup = false;
  }

  HideSMSEmail(e: any) {
    this.showBulkSmsPopup = false;
  }

  HideWhatsAppPopup(e: any) {
    this.showBulkWhatsAppPopup = false;
  }

  hideTaskCreate(e: any) {
    this.showTaskCreate = false;
  }

  get ClientIds(): number[] {
    return this.filterUniqueNumbers(this.columnData.getValue().map((o: any) => parseInt(o.clt_id)));
  }

  
filterUniqueNumbers(array: number[]): number[] {
  const counts: { [key: number]: number } = {}; 
  const uniqueNumbers: number[] = [];
  array.forEach((number) => {
    counts[number] = (counts[number] || 0) + 1;
  });
  array.forEach((number) => {
    if (counts[number] === 1) {
      uniqueNumbers.push(number);
    }
  });
  return uniqueNumbers;
}

}